import { Configuration, TmxApi } from '@iwoca/iwocapay-api-client';

import { getRuntimeEnvironment } from '../utils/getRuntimeEnvironment';

const getIwocapayServiceBasePath = () => {
  const overrideUrl = import.meta.env.VITE_IWOCAPAY_SERVICE_URL;

  if (overrideUrl) return overrideUrl;

  switch (getRuntimeEnvironment()) {
    case 'PRODUCTION':
      return 'https://iwocapay.iwoca.co.uk';
    default:
      return 'https://iwocapay.iwoca-dev.co.uk';
  }
};

const configuration = new Configuration({
  basePath: getIwocapayServiceBasePath(),
  credentials: 'include',
});

export const tmxApi = new TmxApi(configuration);
